import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, MapPin, Building } from 'lucide-react';
import { Logo } from '../common';
import Footer from '../common/Footer';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white text-black font-sans antialiased flex flex-col justify-between">
      <div>
        {/* Navigation */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-zinc-200">
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="flex items-center justify-between h-20">
              <Logo />
              <div className="hidden lg:flex items-center gap-6">
                <Link to="/pricing" className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-600 hover:text-black transition-colors">Pricing</Link>
                <Link to="/apply" className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-600 hover:text-black transition-colors">Open Account</Link>
                <Link to="/contact" className="font-mono text-xs uppercase tracking-[0.15em] text-black font-bold border-b-2 border-black pb-1">Contact</Link>
                <Link to="/login" className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-800 hover:text-black font-medium">Platform Login</Link>
              </div>
            </div>
          </div>
        </nav>

        {/* Header Banner */}
        <div className="pt-32 pb-16 bg-[#4D4D4D] text-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-zinc-300 hover:text-white mb-6">
              <ArrowLeft className="w-4 h-4" /> Back to Home
            </Link>
            <span className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-300 block mb-2">Get in Touch</span>
            <h1 className="font-sans text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">Contact us</h1>
            <p className="font-sans text-base text-zinc-300 max-w-2xl">
              Reach out to the Forwardsflow team for frontier fixed income investment, bank partnerships, or platform support.
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* General Enquiries */}
            <div className="bg-white border border-zinc-300 p-8 rounded-none hover:border-[#4D4D4D] transition-all">
              <span className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-400 block mb-3">Communication Channels</span>
              <h2 className="font-sans text-xl font-bold text-black mb-6">General enquiries</h2>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 border border-zinc-300 bg-zinc-50 rounded-none flex items-center justify-center">
                    <Mail className="w-4 h-4 text-black" />
                  </div>
                  <div>
                    <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-400">Email</p>
                    <a href="mailto:info@forwardsflow.com" className="font-sans text-sm text-black font-medium hover:underline">info@forwardsflow.com</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 border border-zinc-300 bg-zinc-50 rounded-none flex items-center justify-center">
                    <Phone className="w-4 h-4 text-black" />
                  </div>
                  <div>
                    <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-400">Direct Desk</p>
                    <a href="tel:+254785654887" className="font-sans text-sm text-black font-medium hover:underline">+254 785 654 887</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Headquarters */}
            <div className="bg-white border border-zinc-300 p-8 rounded-none hover:border-[#4D4D4D] transition-all">
              <span className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-400 block mb-3">Global Offices</span>
              <h2 className="font-sans text-xl font-bold text-black mb-6">Headquarters</h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 border border-zinc-300 bg-zinc-50 rounded-none flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-black" />
                  </div>
                  <div>
                    <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-400">Kenya Regional Operations</p>
                    <p className="font-sans text-sm text-black font-medium">Kofisi Square, 104 Riverside Drive</p>
                    <p className="font-sans text-sm text-zinc-600">Nairobi, Kenya</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 pt-2">
                  <div className="w-9 h-9 border border-zinc-300 bg-zinc-50 rounded-none flex items-center justify-center flex-shrink-0">
                    <Building className="w-4 h-4 text-black" />
                  </div>
                  <div>
                    <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-400">US Corporate Jurisdiction</p>
                    <p className="font-sans text-sm text-black font-medium">Forwards Flow Inc.</p>
                    <p className="font-sans text-sm text-zinc-600">1007 N Orange St. 4th Floor Suite #5592, Wilmington, DE 19801, United States</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;
